<mat-toolbar class="app-footer">
  <div class="row w-100">
    <div class="col-12 col-sm-6">
      <span>&copy; {{ year }} {{ configService.ownerName }} | {{ 'common.words.vatNumber' | translate }} {{ configService.ownerVatNumber }}</span>
    </div> <!-- /.col-sm-6 -->
    <div class="col-12 col-sm-6 text-right">
      {{ 'common.words.developedBy' | translate }} <strong (click)="onCreditLinkClick()" class="sitisrl-link">{{ configService.developerName }}</strong>
    </div> <!-- /.col-sm-6 -->
  </div> <!-- /.row -->
</mat-toolbar>
